import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { TranslationModule } from 'src/app/translation/translation.module';
import { ValidityDetailComponent } from './validity/validity-detail/validity-detail.component';
import { ValidityEditorComponent } from './validity/validity-editor/validity-editor.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatCardModule } from '@angular/material/card';
import { InformationComponent } from './information/information.component';
import { SearchComponent } from './search/search.component';
import { SearchRessourceComponent } from './search/search-ressource/search-ressource.component';
import { FilterModule } from 'src/app/filter/filter.module';
import { TimeIntervalComponent } from './time-interval/time-interval.component';
import { TimeIntervalPipe } from './time-interval/time-interval.pipe';
import { SortItemComponent } from './sort-item/sort-item.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DisplayDataPipe } from 'src/app/resources/display-data.pipe';
import { DataComponent } from './data/data.component';
import { ValidityStatusComponent } from './validity/validity-status/validity-status.component';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
  declarations: [
    ValidityDetailComponent,
    ValidityEditorComponent,
    InformationComponent,
    SearchComponent,
    SearchRessourceComponent,
    TimeIntervalComponent,
    TimeIntervalPipe,
    SortItemComponent,
    DisplayDataPipe,
    DataComponent,
    ValidityStatusComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslationModule,
    MatSelectModule,
    MatDividerModule,
    MatInputModule,
    MatDatepickerModule,
    MatCheckboxModule,
    FlexLayoutModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatListModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatPaginatorModule,
    MatCardModule,
    MatMenuModule,
    FilterModule,
    DragDropModule,
  ],
  exports: [
    ValidityDetailComponent,
    ValidityEditorComponent,
    ValidityStatusComponent,
    InformationComponent,
    SearchComponent,
    SearchRessourceComponent,
    TimeIntervalComponent,
    TimeIntervalPipe,
    SortItemComponent,
    DisplayDataPipe,
    DataComponent,
  ],
})
export class ToolsModule {}
